<template>
  <div 
  class="modal-card" 
  style="width: 100%"
  data-test-id="notificationGroupsModal"
  >
    <header class="modal-card-head">
      <p class="modal-card-title">{{ $t("RelevantGroups", { callerEntityDetails: titleString }) }}</p>
      <b-button icon-pack="fas" icon-left="times" @click="onClose" />
    </header>
    <section class="modal-card-body">
      <notificationGroupDetails
      :notificationGroups="groupsList"
      :showRelatedItems="showRelatedItems"
      />
    </section>
    <footer class="modal-card-foot">
      <b-button @click="onClose">{{ $t("Close") }}</b-button>
    </footer>
  </div>
</template>

<script setup lang="ts">
import notificationGroupDetails from "@/components/notifications/notificationGroupDetails.vue";
import type { NotificationGroup } from "@/stores/app";

defineProps<{
  groupsList: NotificationGroup[];
  showRelatedItems: boolean;
  titleString: string;
}>();

const emit = defineEmits<{
  (e: "close"): void;
}>();

const onClose = (): void => {
  emit("close");
};
</script>
